import { callPost } from '../graphql';
import { GET_ADDRESS_ACCOUNT } from '../graphql/query';

export const getAddressAcount = async () => {
    const { data: axiosData } = await callPost(GET_ADDRESS_ACCOUNT, {});
    const { data } = axiosData;
    return data.bagyPayVindiGetAddressAccount;
};
